module.exports = __webpack_public_path__ + "img/bmr-townsfolk.9bf859b4.png";